import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import './fetchInterceptor.ts'; // Global fetch interceptor - must be first
import './index.css';
import { App } from './App.tsx';

// Detect if running inside Capacitor native app
// Capacitor uses https://localhost — browser uses actual domain
const isCapacitorNative = window.location.hostname === 'localhost' && window.location.protocol === 'https:';

// App version - change on each deploy to force cache bust (PWA ONLY)
const APP_VERSION = 'v7.2';

// Version check + reload — ONLY for PWA (browser), NOT for native app
// Native app loads from assets/public/ — no caching issues
if (!isCapacitorNative) {
  const STORED_VERSION = localStorage.getItem('app_version');
  if (STORED_VERSION && STORED_VERSION !== APP_VERSION) {
    console.log(`[PWA] Version changed: ${STORED_VERSION} → ${APP_VERSION}, clearing caches...`);
    localStorage.setItem('app_version', APP_VERSION);
    if ('caches' in window) {
      caches.keys().then(names => Promise.all(names.map(n => caches.delete(n)))).then(() => {
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.getRegistrations().then(regs => {
            regs.forEach(r => r.unregister());
            window.location.reload();
          });
        } else {
          window.location.reload();
        }
      });
    }
  } else {
    localStorage.setItem('app_version', APP_VERSION);
  }

  // Register Service Workers — ONLY for PWA (browser)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('ServiceWorker registered: ', registration.scope);
          registration.update();
        })
        .catch((error) => {
          console.log('ServiceWorker registration failed: ', error);
        });

      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          console.log('Firebase Messaging SW registered: ', registration.scope);
        })
        .catch((error) => {
          console.log('Firebase Messaging SW registration failed: ', error);
        });
    });
  }
} else {
  console.log('[Native] Capacitor app detected — skipping SW registration and version reload');
  // Unregister any leftover service workers from previous installs
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(r => r.unregister());
    });
  }
  // Clear any leftover caches
  if ('caches' in window) {
    caches.keys().then(names => names.forEach(n => caches.delete(n)));
  }
}

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', color: '#A0522D', fontFamily: 'serif', backgroundColor: '#FDF5E6', minHeight: '100vh', textAlign: 'center' }}>
          <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>कुछ गड़बड़ हो गई</h1>
          <p style={{ fontSize: '1.2rem', color: '#CC5500' }}>कृपया पेज को रीलोड करें या होम पर जाएं।</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: '20px', padding: '10px 20px', background: '#A0522D', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '1rem', cursor: 'pointer' }}>
            रीलोड करें
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
